import React, { useEffect, useState, useCallback, useRef } from "react";
import { PostDataAPI } from "../services/PostDataAPI";

const GoogleCaptchaV3 = ({ action, onVerify, refreshTrigger }) => {
    const [siteKey, setSiteKey] = useState("");
    const [token, setToken] = useState(null);
    const lastExecutionTime = useRef(0);
    const prevRefreshTrigger = useRef(null);

    useEffect(() => {
        const fetchSiteKey = async () => {
            try {
                const result = await PostDataAPI("googleCaptcha/getSiteKey");
                if (result.success && result.data) {
                    setSiteKey(result.data);
                } else {
                    console.error("Error fetching site key:", result.message || "Unknown error.");
                }
            } catch (error) {
                console.error("Error fetching site key:", error);
            }
        };
        fetchSiteKey();
    }, []);

    const executeRecaptcha = useCallback(() => {
        //console.log("Executing reCAPTCHA...");

        if (!siteKey || !window.grecaptcha) {
            console.warn("reCAPTCHA not ready yet");
            return;
        }

        const now = Date.now();
        const minInterval = 30000; // 30 seconds

        if (now - lastExecutionTime.current < minInterval) {
            console.log("Skipping reCAPTCHA execution: too soon");
            return;
        }

        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute(siteKey, { action })
                .then((newToken) => {
                    console.log("New reCAPTCHA token:", newToken);
                    setToken(newToken);
                    lastExecutionTime.current = now;
                    if (onVerify) onVerify(newToken);
                })
                .catch((error) => {
                    console.error("Error executing reCAPTCHA:", error);
                });
        });
    }, [siteKey, action, onVerify]);

    useEffect(() => {
        //console.log("refreshTrigger changed:", refreshTrigger);
        if (refreshTrigger && refreshTrigger !== prevRefreshTrigger.current) {
            executeRecaptcha();
            prevRefreshTrigger.current = refreshTrigger;
        }
    }, [refreshTrigger]); 

    return null;
};

export default GoogleCaptchaV3;
